import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'areana-eq-wkspc-card',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, MatButtonModule],
  templateUrl: './areana-eq-wkspc-card.component.html',
  styleUrl: './areana-eq-wkspc-card.component.scss',
})
export class ArenaEQWkspcCardComponent {
  @Input() title: string = '';
  @Input() subTitle: string = '';
  @Input() class: string = '';
  @Input() headerClass: string = 'card-header'
}
